import React, { useState } from "react";
import "./CollapseFragment.css";

interface myComponentProps {
  title?: string;
  children?: React.ReactNode;
  collapse?: boolean;
  collapseHeight?: string;
  className?: string;
  onCollapse?: () => void;
  disableDefaultControl?: boolean;
  iconColor?: string;
  iconSize?: string;
  titleSize?: string;
  titleColor?: string;
  collapseIcon?: any;
  hideCollapseIcon?: boolean;
  hideTitle?: boolean;
  icon?: React.ReactNode;
  style?: React.CSSProperties;
}

const CollapseFragment = ({
  children,
  className,
  collapse,
  collapseHeight,
  title,
  onCollapse,
  disableDefaultControl,
  iconColor,
  iconSize,
  titleSize,
  titleColor,
  collapseIcon,
  hideCollapseIcon,
  hideTitle,
  icon,
  style,
}: myComponentProps) => {
  const [defaultCollapse, setDefaultCollapse] = useState(false);

  const dropIcon = (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="img"
    >
      <path d="M8 10.5L12 14.5L16 10.5" stroke={iconColor || "#596080"} />
    </svg>
  );

  return (
    <div
      className={`reusable-collapse-fragment-box-index-wrapper ${
        !disableDefaultControl && !defaultCollapse
          ? `reusable-collapse-fragment-box-index-wrapper-open`
          : ``
      } ${
        disableDefaultControl && !collapse
          ? `reusable-collapse-fragment-box-index-wrapper-open`
          : ``
      } ${className ? className : ""}`}
      style={
        {
          "--title-size": titleSize || "1.45rem",
          "--collapse-height": collapseHeight || "30rem",
          "--title-color": titleColor || "black",
          "--icon-size": iconSize || "3rem",
          ...style,
          //   gap: !collapse || !defaultCollapse ? "1rem" : "0rem"
        } as React.CSSProperties
      }
    >
      {/* title drop icon start  */}
      {!hideTitle && (
        <div
          onClick={() => {
            if (!disableDefaultControl) {
              setDefaultCollapse(!defaultCollapse);
            } else {
              onCollapse && onCollapse();
            }
          }}
          className="title-drop-icon-box"
        >
          {icon ? (
            <>
              {" "}
              <div className="icon-wrap">
                <figure className="img-box">{icon}</figure>
              </div>
            </>
          ) : (
            ""
          )}
          <p className="title-collapse">{title || "Title"}</p>
          {!hideCollapseIcon && (
            <div className="icon-box">
              <figure className="img-box">
                {collapseIcon ? collapseIcon : dropIcon}
              </figure>
            </div>
          )}
        </div>
      )}
      {/* title drop icon end  */}
      {/* collapse box start */}
      <div className="collapse-outer-box">
        <div className="collapse-inner-box">{children}</div>
      </div>
      {/* collapse box end */}
    </div>
  );
};

export default CollapseFragment;
